import request from './request';

export async function update(params) {
  return await request('post', `/apiv2/user/plan`, params);
}

export async function list() {
  return await request('get', `/apiv2/user/plan/list`);
}

export async function supportCustomPricing(params) {
  return await request('post', `/apiv2/user/plan/custom-pricing`, params);
}